import { render, staticRenderFns } from "./VerificationMethodSelectionStep.vue?vue&type=template&id=05c77d64&scoped=true&"
import script from "./VerificationMethodSelectionStep.vue?vue&type=script&lang=js&"
export * from "./VerificationMethodSelectionStep.vue?vue&type=script&lang=js&"
import style0 from "./VerificationMethodSelectionStep.vue?vue&type=style&index=0&id=05c77d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c77d64",
  null
  
)

export default component.exports